import React from 'react';
import { Button, Alert } from 'react-bootstrap';
import { Info } from 'lucide-react';

export function ExportData() {
  return (
    <div style={{ flexGrow: 1 }}>
      <h2 style={{ fontSize: '1.75rem', marginBottom: '1rem' }}>Request an export of your data</h2>

      <Alert 
        variant="primary" 
        style={{
          display: 'flex',
          marginBottom: '1rem',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
        }}
      >
        <div 
          style={{
            backgroundColor: '#0d6efd',
            padding: '0.5rem',
            borderRadius: '0.25rem',
            marginRight: '1rem',
          }}
        >
          <Info style={{ color: 'white' }} size={24} />
        </div>
        <div style={{ flexGrow: 1 }}>
          You may download a copy of all data you have created on this platform. Click the button below to 
          start a new request. An email will be sent to you to verify the request. Then the site admin will 
          review your request and if approved, a zip file will be generated and emailed to you.
        </div>
      </Alert>

      <Button 
        variant="primary"
        size="lg"
        style={{
          backgroundColor: '#0d6efd',
          borderColor: '#0d6efd',
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          borderRadius: '0.5rem',
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#0b5ed7';
          e.target.style.borderColor = '#0a58ca';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#0d6efd';
          e.target.style.borderColor = '#0d6efd';
        }}
      >
        Request Data Export
      </Button>
    </div>
  );
}
